import { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus, Import, Document } from '@teo/components/icons';
import { createNewPublication } from '../../constants/sidebar.constants';
import { Button } from '@teo/components';
import { NavContext } from '@/components/NavContext';
import Hint from '../Hints/Hints';
import { HintsContext } from '@/components/Contexts/HintsContext';
import { CreateNewImport } from './CreateNewImport';
import { CreateNewTemplatet } from './CreateNewTemplatet';

const CreateNewPublication = ({
  setIsOpenTypeModal,
  isMobile,
  setTypeCourse,
  authUser,
}: any) => {
  const { t } = useTranslation();
  const { hints } = useContext(HintsContext);
  const [isActive, setActive] = useState(false);
  const { collapsed, setCollapsed } = useContext(NavContext);
  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const [showTemplatetModal, setShowTemplatetModal] = useState<boolean>(false);

  const ref = useRef(null);

  const handleToggle = () => {
    setActive(!isActive);
  };

  const useOutsideClick = (ref: any, callback: any) => {
    const handleClick = (e: any) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClick);

      return () => {
        document.removeEventListener('click', handleClick);
      };
    });
  };

  useOutsideClick(ref, () => {
    setActive(false);
  });

  useEffect(() => {
    if (showImportModal || showTemplatetModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showImportModal, showTemplatetModal]);

  const courseType = authUser?.useCourse;
  const assessmentType = authUser?.useAssessment;
  const vacancyType = authUser?.useLeervacature;
  const instructionType = authUser?.useInstruction;
  const lpType = authUser?.useLp;

  if (
    !courseType &&
    !assessmentType &&
    !vacancyType &&
    !instructionType &&
    !lpType
  )
    return null;

  if (showImportModal) {
    return (
      <CreateNewImport setIsOpen={setShowImportModal} typeCourse="course" />
    );
  }

  if (showTemplatetModal) {
    return (
      <CreateNewTemplatet
        setIsOpen={setShowTemplatetModal}
        typeCourse="course"
      />
    );
  }

  return (
    <div
      className={`relative mb-3 w-full ${
        hints?.id == 'hint_25' &&
        'active-hint-parent active-hint-parent_sidebar !z-[100]'
      }`}
      ref={ref}
    >
      <button
        className="flex items-center gap-3 rounded-full px-6 py-3 shadow-[0_4px_12px_0_rgba(0,0,0,0.12)] hover:bg-grey-01"
        onClick={handleToggle}
      >
        <Hint
          key={'hint_25'}
          id={'hint_25'}
          leftDots={'-left-2 top-2.5'}
          title={t('hint.title_25')}
          order={25}
          style={{
            left: '110%',
            top: '-10px',
          }}
        />
        <Plus className="w-6 text-primary-05" />
        {t('pages.create_publication.new')}
      </button>
      {isActive && hints?.id != 'hint_25' && (
        <div
          className={`${
            !isMobile && 'absolute left-0 top-full'
          }  z-[10] mt-2 min-w-60 min-w-60 rounded-lg bg-white p-2 drop-shadow-m`}
        >
          <div className="flex flex-col gap-3">
            {createNewPublication?.map((el: any, index: any) => {
              const Icon = el.icon;
              if (!courseType && el?.type === 'courses') return null;
              if (!assessmentType && el?.type === 'assessments') return null;
              if (!vacancyType && el?.type === 'vacancies') return null;
              if (!instructionType && el?.type === 'instructions') return null;
              if (!lpType && el?.type === 'learning-paths') return null;
              return (
                <Button
                  variant="ghost"
                  className="flex items-center gap-3"
                  key={index}
                  onClick={() => {
                    if (el?.type !== 'learning-paths') {
                      setTypeCourse(el?.to);
                      setIsOpenTypeModal(true);
                      isMobile && setCollapsed(!collapsed);
                      handleToggle();
                    } else {
                      setTypeCourse(el?.to);
                      setIsOpenTypeModal(true);
                      isMobile && setCollapsed(!collapsed);
                      handleToggle();
                      // navigate(
                      //   `/${authLang}/create/${authOrg}/learning-paths/1`
                      // );
                    }
                  }}
                >
                  <Icon className={'w-6 fill-grey-06 text-grey-06'} />{' '}
                  {t(el.text)}
                </Button>
              );
            })}

            <Button
              variant="ghost"
              className="flex items-center gap-3"
              onClick={() => {
                isMobile && setCollapsed(!collapsed);
                setShowTemplatetModal(true);
              }}
            >
              <Document className="w-6 text-grey-06" />{' '}
              {t('pages.create_publication.template')}
            </Button>
            <div className="-ml-2 -mr-2 border-t px-2 pt-2">
              <Button
                variant="ghost"
                className="flex w-full items-center gap-3"
                onClick={() => {
                  isMobile && setCollapsed(!collapsed);
                  setShowImportModal(true);
                }}
              >
                <Import className="w-6 text-grey-06" />{' '}
                {t('pages.create_publication.import')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export { CreateNewPublication };
